<template>
  <div v-loading="loading" element-loading-spinner="atom-audit-loader">
    <div v-if="!loading">
      <div>
        <el-row style="margin: 10px 0px 30px 0px;">
          <el-col :span="7">
            <div class="button-group-container">
              <el-popover placement="right" ref="newRecordPopover" :title="isAsc ? 'New Ambulatory Record' : 'New Outpatient Record'" width="300" trigger="click" @after-enter="handleNewRecordEnter">
                <el-form size="mini" id="addForm" :model="addForm" :inline="true" ref="addForm" :rules="rules" label-position="left" label-width="180px" v-loading="isPosting" element-loading-spinner="atom-audit-loader">
                  <el-form-item prop="patientNumber" label="New Patient Number">
                    <input id="newPatientNumber" style="height: 22px;" class="hia-el-input el-input__inner" type="addReview" v-model="addForm.patientNumber" maxlength="12" />
                  </el-form-item>

                  <el-form-item prop="patientTypeId" label="Patient Type">
                    <hia-el-select v-model="addForm.patientTypeId" placeholder="Patient Type" :filterable="true" :itemkey="'key'" :label="'value'" :dropdowns="isAsc ? dropdowns.ambulatoryPatientTypes.list : dropdowns.outpatientPatientTypes.list"> </hia-el-select>
                  </el-form-item>

                  <el-form-item v-if="!this.project.clientId" label="Facility" prop="clientId">
                    <hia-el-select v-model="addForm.clientId" placeholder="Facility" :filterable="true" itemkey="key" label="value" :dropdowns="dropdowns.clients.list"> </hia-el-select>
                  </el-form-item>

                  <center>
                    <el-button-group style="margin-top: 10px;">
                      <el-button class="hiaButton" plain round type="text" size="mini" @click="closeNewRecordPopover">Cancel</el-button>
                      <el-button class="hiaButton" round :disabled="!addForm.patientNumber || !addForm.patientTypeId" size="mini" @click="addReview">Add </el-button>
                    </el-button-group>
                  </center>
                </el-form>

                <el-button class="hiaButton" slot="reference" :disabled="getSelectedRecords().length > 0 || (readOnly() && !projectManagement())" plain round size="mini" icon="el-icon-plus">New Record</el-button>
              </el-popover>

              <el-button :disabled="readOnly() && !projectManagement()" class="hiaButton" plain round v-if="getSelectedRecords().length > 0" size="mini" @click="showMassUpdateDialog = true">Mass Update </el-button>
              <el-button :disabled="readOnly() && !projectManagement()" class="hiaButton" plain round v-if="getSelectedRecords().length > 0" size="mini" @click="showMassDeleteDialog = true">Mass Delete </el-button>
              <el-popover v-if="getSelectedRecords().length > 0" placement="bottom" width="320" trigger="click">
                <p>Use the <strong>Rebuttal Tracking</strong> tab to Notify Coders.</p>
                <el-button slot="reference" :disabled="readOnly() && !projectManagement()" class="hiaButton" plain round size="mini">Notify Coders </el-button>
              </el-popover>
              <el-button :disabled="readOnly() && !projectManagement()" class="hiaButton" plain round v-if="tenantSetup.enableLevel2Audits && getSelectedRecords().length > 0" size="mini" @click="showLevel2AuditDialog = true">Level 2 Import </el-button>
            </div>
          </el-col>

          <el-col :span="10">
            <center class="stats">
              <el-badge class="item" :class="{ 'stats-loading': statsLoading }" :value="statistics.allRecords">
                <el-tag type="primary" size="small">All Records</el-tag>
              </el-badge>
              <el-badge class="item" :class="{ 'stats-loading': statsLoading }" :value="statistics.notStarted">
                <el-tag type="primary" size="small">Not Started</el-tag>
              </el-badge>
              <el-badge class="item" :class="{ 'stats-loading': statsLoading }" :value="statistics.inProgress">
                <el-tag type="primary" size="small">In Progress</el-tag>
              </el-badge>
              <el-badge class="item" :class="{ 'stats-loading': statsLoading }" :value="statistics.preliminary">
                <el-tag type="primary" size="small">Preliminary</el-tag>
              </el-badge>
              <el-badge class="item" :class="{ 'stats-loading': statsLoading }" :value="statistics.readyForCoder">
                <el-tag type="primary" size="small">Ready for Coder</el-tag>
              </el-badge>
              <el-badge class="item" :class="{ 'stats-loading': statsLoading }" :value="statistics.completed">
                <el-tag type="primary" size="small">Completed</el-tag>
              </el-badge>
            </center>
          </el-col>
          <el-col :span="7">
            <el-row :gutter="2">
              <el-col :span="24">
                <el-input size="mini" placeholder="filter all..." type="text" id="globalSearch" v-model="filterCriteria" v-on:keyup.native="runGlobalFilter($event)"> </el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <div class="margin-top-5">
          <v-server-table v-if="sortableShow" ref="opReviewListGrid" id="opReviewListGrid" :columns="columns" :options="options" class="hiaTable" @loading="tableLoader = true" @loaded="tableLoader = false" v-loading="tableLoader" element-loading-spinner="atom-audit-loader">
            <template slot="selected" slot-scope="props">
              <input :disabled="readOnly() && !projectManagement()" v-model="props.row.checked" @click="selectRecord(props.row, $event)" type="checkbox" />
            </template>
            <template slot="patientNumber" slot-scope="props">
              <div>
                <!-- <router-link v-bind:to="$route.path + '/' + props.row.ascTableId">{{props.row.patientNumber}}</router-link> -->
                <router-link v-bind:to="'/reviews/outpatient/' + props.row.ascTableId"> {{ props.row.patientNumber ? props.row.patientNumber : 'No Patient Number' }}</router-link>
              </div>
            </template>
            <template slot="dateOfService" slot-scope="props">
              <div>
                {{ props.row.dateOfService ? formatDate(props.row.dateOfService) : '' }}
              </div>
            </template>
            <template slot="completeDate" slot-scope="props">
              <div>
                {{ props.row.completeDate ? formatDate(props.row.completeDate) : '' }}
              </div>
            </template>
            <template slot="reviewDate" slot-scope="props">
              <div>
                {{ props.row.reviewDate ? formatDate(props.row.reviewDate) : '' }}
              </div>
            </template>
            <template slot="level2ReasonForChange" slot-scope="props">
              <div>
                {{ props.row.reviewLevel !== 'Coding Review' ? props.row.level2ReasonForChange : '' }}
              </div>
            </template>

            <template slot="recordTags" slot-scope="props">
              <template v-if="props.row.recordTags">
                <div class="el-tag el-tag--mini el-tag--light" style="max-width: 100px; " v-for="tag in props.row.recordTags.split(',')" :key="tag">
                  <div :title="tag" style="overflow: hidden; text-overflow: ellipsis;">
                    {{ tag }}
                  </div>
                </div>
              </template>
            </template>

            <template slot="delete" slot-scope="props">
              <el-popover v-if="(readOnly() && projectManagement()) || !readOnly()" :ref="'delete_' + props.row.ascTableId" :popper-class="'delete_' + props.row.ascTableId" trigger="click" placement="left" width="190">
                <center>
                  <p>Delete this Chart?</p>
                  <el-button-group>
                    <el-button class="hiaButton" plain round type="text" size="mini" @click="deleteChart(props, 'delete_' + props.row.ascTableId, false)">Cancel</el-button>
                    <el-button class="hiaButton" plain round size="mini" @click="deleteChart(props, 'delete_' + props.row.ascTableId, true)">Confirm</el-button>
                  </el-button-group>
                </center>
                <div slot="reference">
                  <div title="delete" style="text-align: center; cursor: pointer;">
                    <i class="el-icon-close delete-button"></i>
                  </div>
                </div>
              </el-popover>
            </template>
            <template slot="reimbDiff" slot-scope="props">
              <span v-if="props.row.reimbDiff !== 0" :class="`${props.row.reimbDiff < 0 ? 'negative' : ''}`" :title="`Weight Diff: ${props.row.weightDiff}`"> ${{ formatMoney(props.row.reimbDiff) }}</span>
            </template>
          </v-server-table>
        </div>
      </div>
      <div id="dialogs">
        <el-dialog :title="opListSelected.length > 0 ? 'Notify coders' : 'No Records Selected'" :visible.sync="showNotifyCoders">
          <v-client-table class="hiaTable" id="proReviewListNotifyCoders" ref="proReviewListNotifyCoders" :data="notifyCodersData" :columns="['coder', 'coderEmail', 'recordCount']" :options="notifyCodersOptions" element-loading-spinner="atom-audit-loader">
            <template slot="coder" slot-scope="props">
              {{ props.row.coder ? props.row.coder : '[not specified]' }}
            </template>
            <template slot="recordCount" slot-scope="props">
              {{ props.row.records.length }}
            </template>
            <template slot="child_row" slot-scope="props">
              <v-client-table style="width: 97%;float: right;" class="hiaTable" :data="props.row.records" :columns="['patientNumber', 'finalOutcome', 'agreeWithCodes']" :options="notifyCodersOptions" element-loading-spinner="atom-audit-loader">
                <template slot="patientNumber" slot-scope="props">
                  <a href="" @click.stop.prevent="reviewListChildRowLink(props)">{{ props.row.patientNumber }}</a>
                </template>
              </v-client-table>
            </template>
            <template slot> </template>
          </v-client-table>

          <small>Notifications can only be sent to coders with email addresses</small>
          <span slot="footer">
            <el-button-group>
              <el-button @click="postNotifyCoders()" size="mini" plain round>Confirm</el-button>
              <el-button @click="showNotifyCoders = false" size="mini" plain round>Cancel</el-button>
            </el-button-group>
          </span>
        </el-dialog>

        <el-dialog :visible.sync="showValidationDialog" @open="getValidation" @close="CLEAR_VALIDATION_LIST" :title="getValidationDialogTitle()">
          <div v-loading="validationsLoading" element-loading-spinner="atom-audit-loader">
            <el-table ref="validationList" id="validationList" size="mini" :data="opListRecordValidations" row-key="recordId" stripe>
              <el-table-column type="expand" width="80">
                <template slot-scope="props">
                  <RecordValidation :validationMessages="props.row.recordValidations"> </RecordValidation>
                </template>
              </el-table-column>
              <el-table-column label="Patient Number" width="250">
                <template slot-scope="props">
                  <router-link :to="`/reviews/pro/${props.row.recordId}`" @click.native="showValidationDialog = false"> {{ props.row.patientNumber }}</router-link>
                </template>
              </el-table-column>
              <el-table-column label="Date of Service">
                <template slot-scope="props">
                  {{ props.row.dateOfService ? formatDate(props.row.dateOfService) : '' }}
                </template>
              </el-table-column>
              <el-table-column prop="consultantNumber" label="Consultant Number"> </el-table-column>
              <el-table-column label="Errors">
                <template slot-scope="props">
                  {{ props.row.recordValidations.length }}
                  {{ props.row.recordValidations.length === 1 ? 'Error' : 'Errors' }}
                </template>
              </el-table-column>
            </el-table>
            <el-row>
              <el-button type="primary" class="pull-right" style="margin: 20px 0px 0px 0px;" size="mini" @click="showValidationDialog = false">Close</el-button>
            </el-row>
          </div>
        </el-dialog>
        <OutpatientReviewMassUpdate v-if="showMassUpdateDialog" @massupdate="handleMassUpdate" @close="showMassUpdateDialog = false" :showMassUpdateDialog="showMassUpdateDialog" :clients="dropdowns.clients.list" :selectedRecords="getSelectedRecords()" :selectedClients="getSelectedClients()"> </OutpatientReviewMassUpdate>

        <ReviewsMassDelete v-if="showMassDeleteDialog" @massDelete="runMassDelete" @close="closeMassDeleteDialog()" :idType="'ascTableId'" :showMassDeleteDialog="showMassDeleteDialog" :selectedRecords="opListSelected" :massDeleteData="massDeleteData" :massDeleteLoading="massDeleteLoading"> </ReviewsMassDelete>

        <el-dialog
          :title="opListSelected.length > 0 ? 'Level 2 Import' : 'No Records Selected'"
          :visible.sync="showLevel2AuditDialog"
          @close="
            copyToLevel2SuccessMessage = false
            copyToLevel2ErrorMessage = null
          "
        >
          <div v-loading="copyToLevel2Loading" element-loading-spinner="atom-audit-loader">
            <template v-if="!copyToLevel2SuccessMessage">
              <p style="margin: 0 0 10px 0; font-weight: 500; color: #303133; font-size: 14px;"><span style="color: #f56c6c; margin-left: 4px; margin-right: 4px;">*</span>Select Target Project</p>
              <projectSelector v-model="targetLevel2ProjectId" @selected="targetLevel2Project = $event" :project="targetLevel2Project" :defaultQuery="{ projectTypeId: project.projectTypeId }"> </projectSelector>

              <p style="margin: 20px 0 10px 0; font-weight: 500; color: #303133; font-size: 14px;"><span style="color: #f56c6c; margin-left: 4px; margin-right: 4px;">*</span>Select Code Type</p>
              <el-select v-model="targetCodeType" placeholder="Select Code Type" style="width: 100%;" :disabled="copyToLevel2Loading">
                <el-option v-for="item in dropdowns.codeTypes.list" :key="item.key" :label="item.value" :value="parseInt(item.key)" :disabled="item.inactive"> </el-option>
              </el-select>

              <div style="display: flex; align-items: flex-start; margin-top: 20px; padding: 12px 16px; background-color: #f4f4f5; border-left: 4px solid #409eff; border-radius: 4px;">
                <i class="el-icon-info" style="color: #409eff; font-size: 16px; margin-right: 8px; margin-top: 2px; flex-shrink: 0;"></i>
                <small style="color: #606266; line-height: 1.5; display: block; flex: 1; word-break: normal; overflow-wrap: break-word;">Records will be copied to the target project and reset for Level 2 Auditing of the original auditor's work.</small>
              </div>

              <el-alert v-if="copyToLevel2ErrorMessage" style="margin-top: 20px;" type="error" :closable="false" show-icon>
                {{ copyToLevel2ErrorMessage }}
              </el-alert>
            </template>

            <div v-if="copyToLevel2SuccessMessage" style="margin-top: 20px; font-size: 14px;">
              Records copied succesfully. Go to the target project <a :href="`/projects/${targetLevel2ProjectId}`" target="_blank">here <i class="el-icon-top-right"></i></a>
            </div>
            <div style="margin-top: 10px; height: 60px;">
              <el-button-group style="float: right; margin-top: 40px;">
                <el-button
                  class="hiaButton"
                  plain
                  round
                  type="text"
                  @click="
                    showLevel2AuditDialog = false
                    copyToLevel2SuccessMessage = false
                    copyToLevel2ErrorMessage = null
                  "
                  >Close</el-button
                >
                <el-button class="hiaButton" plain round :disabled="!targetLevel2ProjectId || !targetCodeType || copyToLevel2Loading || copyToLevel2SuccessMessage" @click="createLevel2Audit()">Confirm</el-button>
              </el-button-group>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import OutpatientReviewMassUpdate from '@/views/reviews/outpatient/OutpatientReviewMassUpdate'
  import ReviewsMassDelete from '@/components/controls/ReviewsMassDelete'
  import projectSelector from '@/components/controls/projectSelector'

  import hiaTable from '@/mixins/hiaTable'
  import dateHelper from '@/mixins/date-helper'
  import RecordValidation from '@/components/controls/RecordValidation'
  import Sortable from 'sortablejs'
  import HiaAuthorization from '@/mixins/hiaAuthorization'
  import debounce from 'debounce'
  import money from '@/mixins/money'
  export default {
    name: 'opList',
    mixins: [dateHelper, hiaTable, HiaAuthorization, money],
    data() {
      return {
        showNotifyCoders: false,
        vueTables2Query: {},
        statsLoading: false,
        dropdownsNeeded: ['reviewLevels', 'clients', 'ambulatoryPatientTypes', 'outpatientPatientTypes', 'reviewStatus', 'outpatientGroupers', 'codeTypes'],
        massDeleteData: {
          deleted: [],
          notDeleted: []
        },
        showMassDeleteDialog: false,
        showLevel2AuditDialog: false,
        showImportRebuttalsDialog: false,
        showValidationDialog: false,
        targetLevel2ProjectId: null,
        targetLevel2Project: null,
        targetCodeType: null,
        copyToLevel2SuccessMessage: false,
        copyToLevel2ErrorMessage: null,
        copyToLevel2Loading: false,
        massDelete: false,
        massDeleteLoading: false,
        validationsLoading: false,
        loading: true,
        isPosting: false,
        isActivated: false,
        showRecordStats: {
          show: false,
          recordId: 0
        },
        clients: [],
        selectedClientNumber: '',
        doubleClickPreventer: false,
        reviewDate: '',
        showAddReviewForm: false,
        showMassUpdateDialog: false,
        massupdateDropdowns: [],
        disableAddReview: true,
        addForm: {
          patientNumber: null,
          patientTypeId: null,
          clientId: null
        },
        rules: {
          patientNumber: [{ required: true, message: 'Please set Patient Number', trigger: 'blur' }],
          patientTypeId: [{ required: true, message: 'Please set Patient Type', trigger: 'none' }],
          clientId: [{ required: true, message: 'Please set Facility', trigger: 'none' }]
        },
        choices: false,
        filterCriteria: '',
        tableLoader: false,
        columns: ['selected', 'patientNumber', 'patientType', 'mrNumber', 'consultantNumber', 'recordTags', 'payorName', 'coder', 'reasonForChange', 'dateOfService', 'reviewDate', 'status', 'auditResult', 'agreeWithCodes', 'finalOutcome', 'responseCount', 'comments', 'reimbDiff', 'delete'],
        options: {
          actionsPosition: 'right',
          requestFunction: (data) => {
            return this.requestData(data)
          },
          debounce: 600,
          filterByColumn: true,
          listColumns: {
            reviewLevel: [],
            finalOutcome: []
          },
          sortable: ['patientNumber', 'patientType', 'mrNumber', 'consultantNumber', 'recordTags', 'payorName', 'coder', 'reasonForChange', 'dateOfService', 'reviewDate', 'status', 'auditResult', 'agreeWithCodes', 'finalOutcome', 'responseCount', 'comments', 'reimbDiff', 'originalAuditor'],
          orderBy: {
            column: 'patientNumber',
            ascending: true
          },
          columnsClasses: {
            selected: 'selected',
            recordTags: 'tagsCol',
            delete: 'delete'
          },
          headings: {
            selected: (h) => {
              return h('input', {
                attrs: {
                  type: 'checkbox',
                  id: 'selectAllCheckboxOpList',
                  disabled: this.readOnly() && !this.projectManagement()
                },
                on: {
                  click: (e) => {
                    this.localSelectAll(e.srcElement.checked)
                  }
                },
                ref: 'selectAllCheckbox'
              })
            },
            patientNumber: 'Patient Number',
            consultantNumber: 'Auditor',
            payorName: 'Payor',
            mrNumber: 'MR Number',
            coder: 'Coder',
            patientType: 'Pat Type',
            recordTags: 'Record Tags',
            physicianName: 'Provider',
            dateOfService: 'Date of Service',
            reasonForChange: 'Reason F Change',
            comments: 'Comments',
            reviewDate: 'Review Date',
            delete: '',
            auditResult: 'Audit Result',
            agreeWithCodes: 'Coder Agrees',
            reimbDiff: 'Reimb. Diff',
            responseCount: 'Response Count',
            finalOutcome: 'Final Outcome',
            originalAuditor: 'Original Auditor'
          },
          perPage: 25,
          texts: {
            filter: '',
            filterBy: '...'
          },
          highlightMatches: true,
          sortIcon: { is: 'none' }
        },
        theOPsortable: null,
        sortableShow: true,
        sortableColumns: [
          { key: 'selected', title: 'selected', selected: true },
          { key: 'patientNumber', title: 'Patient Number', selected: true },
          { key: 'physicianName', title: 'Provider', selected: true },
          { key: 'numberEMCodes', title: '# EM Codes', selected: true },
          { key: 'numberCPTCodes', title: '# CPT Codes', selected: true },
          { key: 'numberFindings', title: '# Compliance Findings', selected: true },
          { key: 'level2NumberFindings', title: '# Lvl 2 Findings', selected: true },
          { key: 'mrnumber', title: 'MR Number', selected: true },
          { key: 'consultantNumber', title: 'Consultant Number', selected: true },
          { key: 'payorName', title: 'Payor', selected: true },
          { key: 'coder', title: 'Coder', selected: true },
          { key: 'reasonForChange', title: 'Reason F Change', selected: true },
          { key: 'reviewLevel', title: 'Review Date', selected: true },
          { key: 'originalReviewer', title: 'Orig Reviewer', selected: true },
          { key: 'level2ReasonForChange', title: 'Lvl 2 Reason F Change', selected: true },
          { key: 'dateofService', title: 'Date of Service', selected: true },
          { key: 'placeOfService', title: 'Place of Service', selected: true },
          { key: 'providerType', title: 'Provider Type', selected: true },
          { key: 'practiceName', title: 'practiceName', selected: true },
          { key: 'patientName', title: 'Patient Name', selected: true },
          { key: 'completeDate', title: 'Complete Date', selected: true },
          { key: 'rebuttalCount', title: 'Rebuttal Count', selected: true },
          { key: 'rebuttalActiveCount', title: 'Active Rebuttals', selected: true },
          { key: 'rebuttalRespondedCount', title: 'Completed Rebuttals', selected: true },
          { key: 'recordStatus', title: 'Record Status', selected: true },
          { key: 'comments', title: 'Comments', selected: true },
          { key: 'numberDxCodes', title: '# Dx Codes', selected: true },
          { key: 'reviewDate', title: 'Review Date', selected: true },
          { key: 'reimbDiff', title: 'Reimb. Diff', selected: true },
          { key: 'delete', title: 'delete', selected: true }
        ],
        defaultColumns: [],
        notifyCodersColumns: ['patientNumber', 'coder', 'coderEmail', 'finalOutcome', 'agreeWithCodes'],
        notifyCodersOptions: {
          filterByColumn: true,
          listColumns: {
            reviewLevel: []
          },
          orderBy: {
            column: 'patientNumber',
            ascending: true
          },
          columnsClasses: {},
          headings: {
            patientNumber: 'Patient Number',
            agreeWithCodes: 'Coder Agrees',
            finalOutcome: 'Final Outcome',
            coderEmail: 'Email',
            coder: 'Coder',
            recordCount: 'Record Count'
          },
          perPage: 25,
          texts: {
            filter: '',
            filterBy: '...'
          },
          highlightMatches: true,
          sortIcon: { is: 'none' },
          uniqueKey: 'coderId'
          // columnsDropdown: true
        }
      }
    },
    methods: {
      ...mapActions('outpatientReviews/', ['POST_VALIDATION', 'RUN_OP_COPYTOLEVEL2', 'POST_OP_RECORD', 'DELETE_OP_RECORD', 'RUN_OP_MASSDELETE', 'LOAD_OP_LIST_PAGINATED', 'OP_RECORD_EXISTS', 'GET_OP_LIST_ALLIDS', 'GET_OPLIST_STATS', 'POST_NOTIFY_CODERS']),
      ...mapActions('dropdowns/', ['GET_DROPDOWNS', 'CONVERT_DROPDOWN_COLUMNFILTERARRAY']),
      ...mapActions('managedLists/tenantSetup/', ['GET_TENANT_SETUP']),
      ...mapMutations('outpatientReviews/', ['SET_OPLIST_SELECTED', 'CLEAR_OPLIST_SELECTED', 'CLEAR_VALIDATION_LIST', 'SET_OPLIST_REFRESH_FUNC']),
      // ...mapActions('profile/', ['SET_PROFILE_COLUMNS']),
      async requestData(data) {
        try {
          data.projectID = this.$route.params.id
          data.globalSearch = this.filterCriteria
          this.vueTables2Query = data
          this.statsLoading = true
          const resultArray = await Promise.all([this.GET_OPLIST_STATS(data), this.LOAD_OP_LIST_PAGINATED(data)])
          this.options.listColumns.finalOutcome = resultArray[1].finalOutcomeFilter
          this.statsLoading = false
          return resultArray[1]
        } catch (err) {
          console.log(err)
        }
      },
      getValidationDialogTitle() {
        if (this.getSelectedRecords().length === 0) {
          return 'No Records Selected'
        }
        if (this.validationsLoading) {
          return 'Validation Results - loading...'
        }
        return `Validation Results - ${this.opListRecordValidations.length} ${this.opListRecordValidations.length === 1 ? 'Record' : 'Records'} With Errors`
      },
      handleAction(action) {
        if (action === 'editColumns') {
          this.showSortableColumns()
        }
        if (action === 'copyToLevel2') {
          this.copyToLevel2.visible = true
        }
        if (action === 'massUpdate') {
          this.showMassUpdateDialog = true
        }
        if (action === 'importRebuttals') {
          this.showImportRebuttalsDialog = true
        }
        if (action === 'massDelete') {
          this.showMassDeleteDialog = true
        }
        if (action === 'validate') {
          this.showValidationDialog = true
        }
      },
      getValidation() {
        const payload = this.getSelectedRecords()
        if (payload.length > 0) {
          this.validationsLoading = true
          this.POST_VALIDATION(payload).then(() => {
            this.validationsLoading = false
          })
        }
      },
      async localSelectAll(checked) {
        const table = this.$refs.opReviewListGrid.$el
        const checkboxes = table.querySelectorAll('input[type ="checkbox"]')

        if (checked) {
          this.tableLoader = true
          await this.GET_OP_LIST_ALLIDS(this.vueTables2Query)
          for (let i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = true
          }
          this.tableLoader = false
        } else {
          this.CLEAR_OPLIST_SELECTED()
          for (let i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = false
          }
        }
      },
      getSelectedRecords() {
        const simpleArray = this.opListSelected.map((y) => y.ascTableId)
        return [...new Set(simpleArray)]
      },
      getSelectedClients() {
        const simpleArray = this.opListSelected.map((y) => y.clientNumber)
        return [...new Set(simpleArray)]
      },
      selectRecord(row, e) {
        const payload = {
          checked: e.srcElement.checked,
          ascTableId: row.ascTableId,
          patientNumber: row.patientNumber,
          clientName: row.clientName,
          coder: row.coder,
          coderId: row.coderId,
          consultantNumber: row.consultantNumber,
          projectId: row.projectId,
          coderEmail: row.coderEmail
        }

        this.SET_OPLIST_SELECTED(payload)
      },
      runCopyToLevel2() {
        if (!this.doubleClickPreventer) {
          this.doubleClickPreventer = true
          this.$refs.copyToLevel2.validate((valid) => {
            if (valid) {
              const payload = {
                consNum: window.user.id,
                projectID: this.copyToLevel2.projectID,
                ids: this.getSelectedRecords()
              }
              this.RUN_OP_COPYTOLEVEL2(payload).then(
                () => {
                  this.CLEAR_OPLIST_SELECTED()
                  this.$refs.opReviewListGrid.getData()
                  this.copyToLevel2.visible = false
                  this.doubleClickPreventer = false
                },
                (error) => {
                  console.log(error)
                  this.doubleClickPreventer = false
                }
              )
            } else {
              console.log('error submit!!')
              this.doubleClickPreventer = false
              return false
            }
          })
        }
      },
      handleMassUpdate(massUpdateModel) {
        const el = document.getElementById('selectAllCheckboxOpList')
        if (el) {
          el.checked = false
        }
        this.showMassUpdateDialog = false
        this.localSelectAll(false) // clear all the selected checkboxes
        this.CLEAR_OPLIST_SELECTED()
        this.$refs.opReviewListGrid.getData()
        if (this.isAsc) {
          if (this.refreshAscRebuttalTracking) {
            this.refreshAscRebuttalTracking()
          }
        } else if (this.refreshOpRebuttalTracking) {
          this.refreshOpRebuttalTracking()
        }
      },
      toggleAddReviewForm() {
        if (this.showAddReviewForm) {
          this.$refs.addForm.clearValidate()
          this.showAddReviewForm = false
          this.addForm.patientNumber = ''
          this.addForm.clientId = null
        } else {
          this.showAddReviewForm = true
        }
      },
      addReview() {
        // use isPosting to prevent double clicks adding two records
        if (!this.isPosting) {
          this.$refs.addForm.validate((valid) => {
            if (valid) {
              this.isPosting = true
              this.postopReview()
            } else {
              console.log('error submit!!')
              return false
            }
          })
        }
      },
      postopReview() {
        const newReview = {
          patientNumber: this.addForm.patientNumber.trim(),
          patientTypeId: this.addForm.patientTypeId,
          clientId: this.project.clientId ? this.project.clientId : this.addForm.clientId,
          providerId: this.project.defaultProviderId,
          coderId: this.project.defaultCoderId,
          reviewDate: this.project.startDate,
          outpatientGrouperId: this.project.outpatientGrouperId,
          projectID: this.projectPK
        }

        this.POST_OP_RECORD(newReview).then(
          (response) => {
            this.$router.push({ path: `/reviews/outpatient/${response.ascTableId}` })
            this.$nextTick(() => {
              this.isPosting = false
              this.$refs.addForm.clearValidate()
              this.addForm.patientNumber = null
              this.addForm.clientId = null
            })
          },
          (error) => {
            console.log(error)
            this.isPosting = false
          }
        )
      },
      recordStatsActivate(condition, recordId) {
        this.showRecordStats = {
          show: condition,
          recordId: recordId
        }
      },
      deleteChart(props, ref, bool) {
        const popper = this.$refs[ref]
        popper.doDestroy()
        popper.doClose()
        if (!bool) {
          return false
        }

        this.tableLoader = true
        this.DELETE_OP_RECORD(props.row.ascTableId).then(
          (response) => {
            this.$message({
              message: 'Chart Deleted Successfully',
              type: 'info'
            })
            this.$refs.opReviewListGrid.getData()
            this.tableLoader = false
          },
          (error) => {
            this.$message({
              message: error.response.data,
              type: 'error'
            })
            console.log(error)
            this.tableLoader = false
          }
        )
      },
      runMassDelete() {
        this.massDeleteLoading = true
        this.RUN_OP_MASSDELETE(this.getSelectedRecords()).then(
          (response) => {
            this.massDeleteData = response.data
            const el = document.getElementById('selectAllCheckboxOpList')
            if (el) {
              el.checked = false
            }
            this.CLEAR_OPLIST_SELECTED()
            this.$refs.opReviewListGrid.getData()
            this.massDeleteLoading = false
          },
          (error) => {
            this.closeMassDeleteDialog()
            this.$message({
              message: 'Error Mass Deleting Records',
              type: 'error'
            })
            console.log(error)
            this.massDeleteLoading = false
          }
        )
      },
      closeMassDeleteDialog() {
        this.showMassDeleteDialog = false
        this.massDeleteData = {
          deleted: [],
          notDeleted: []
        }
      },
      runGlobalFilter: debounce(function() {
        this.$refs.opReviewListGrid.setPage(1)
      }, 400),
      attachSortable(parentElementId, onEndFn) {
        const gridDiv = document.getElementById(parentElementId)
        if (gridDiv) {
          const tbody = gridDiv.getElementsByTagName('thead')[0].getElementsByTagName('tr')[0]
          // add drag class to all except selected and delete
          for (let i = 0; i < tbody.getElementsByTagName('th').length; i++) {
            if (!tbody.getElementsByTagName('th')[i].classList.contains('selected') && !tbody.getElementsByTagName('th')[i].classList.contains('delete')) {
              tbody.getElementsByTagName('th')[i].classList.add('dragOn')
            }
          }
          const localSortable = Sortable.create(tbody, {
            animation: 200,
            draggable: 'th',
            handle: '.dragOn',
            onEnd: (evt) => {
              onEndFn(evt.oldIndex, evt.newIndex)
            }
          })
          this.theOPsortable = localSortable
        }
      },
      handleDragStop(oldIndex, newIndex) {
        const temp = [...this.columns]
        if (newIndex >= temp.length) {
          let j = newIndex - temp.length + 1
          while (j--) {
            temp.push(undefined)
          }
        }
        temp.splice(newIndex, 0, temp.splice(oldIndex, 1)[0])

        // update sortableColumns
        this.sortableColumns.sort((a, b) => {
          return temp.indexOf(a.key) - temp.indexOf(b.key)
        })

        this.columns = temp
        // Couldn't get both the columns and rows to match up so destroying grid/sortable and re-creating grid/sortable sigh...
        this.resetSortableGrid()
      },
      showSortableColumns() {
        const popper = this.$refs.sortableColumns
        popper.referenceElm = this.$refs.sortableColumnsRef
        popper.doShow()
      },
      hideSortableColumns() {
        const popper = this.$refs.sortableColumns
        popper.doClose()
      },
      handleNewRecordEnter() {
        const el = document.getElementById('newPatientNumber')
        el.focus()
      },
      closeNewRecordPopover() {
        const popper = this.$refs.newRecordPopover
        if (popper) {
          popper.doDestroy()
          popper.doClose()
        }
      },
      handleSortableColumns(column) {
        setTimeout(() => {
          if (column.selected) {
            const columnIndex = this.sortableColumns.findIndex((f) => f.key === column.key)
            if (columnIndex !== -1) {
              this.columns.splice(columnIndex, 0, column.key)
              this.resetSortableGrid()
            }
          } else {
            const columnIndex = this.columns.indexOf(column.key)
            if (columnIndex !== -1) {
              this.columns.splice(columnIndex, 1)
              this.resetSortableGrid()
            }
          }
        }, 5)
      },
      handleSortableColumnsUpdate() {
        const payload = {
          type: 'op',
          userGuid: window.user.oid,
          opColumnList: JSON.parse(JSON.stringify(this.sortableColumns))
        }
        this.SET_PROFILE_COLUMNS(payload)
      },
      setUserProfileSortableColumns() {
        // if user profile columns exist set them otherwise use local
        // if (this.userProfile.profile !== null && this.userProfile.profile.opColumnList !== null && this.userProfile.profile.opColumnList !== undefined) {
        //   this.sortableColumns = JSON.parse(JSON.stringify(this.userProfile.profile.opColumnList))
        //   this.columns = this.sortableColumns.filter(f => f.selected).map(m => m.key)
        // } else {
        //   this.columns = this.sortableColumns.map(m => m.key)
        // }
      },
      resetSortableGrid() {
        this.theOPsortable.destroy()
        this.sortableShow = false
        this.$nextTick(() => {
          this.sortableShow = true
          this.$nextTick(() => {
            this.attachSortable('opReviewListGrid', this.handleDragStop)
            this.handleSortableColumnsUpdate()
          })
        })
      },
      resetSortableColumns() {
        const payload = {
          type: 'pro',
          userGuid: window.user.oid,
          opColumnList: JSON.parse(JSON.stringify(this.defaultColumns))
        }
        this.sortableColumns = JSON.parse(JSON.stringify(this.defaultColumns))
        this.columns = this.defaultColumns.filter((f) => f.selected).map((m) => m.key)
        this.SET_PROFILE_COLUMNS(payload)
        this.theOPsortable.destroy()
        this.sortableShow = false
        this.$nextTick(() => {
          this.sortableShow = true
          this.$nextTick(() => {
            this.attachSortable('opReviewListGrid', this.handleDragStop)
          })
        })
      },
      initNotifyCoders() {
        this.showNotifyCoders = !this.showNotifyCoders
      },
      async postNotifyCoders() {
        const notifyCodersData = []
        for (let i = 0; i < this.notifyCodersData.length; i++) {
          const c = this.notifyCodersData[i]
          if (c.coderEmail) {
            notifyCodersData.push({ coder: c.coder, auditor: c.auditor, coderEmail: c.coderEmail, recordCount: c.records.length, myRecordsUrl: `/my-projects/${this.projectPK}?type=Outpatient` })
          }
        }

        try {
          this.showNotifyCoders = true
          await this.POST_NOTIFY_CODERS(notifyCodersData)
          this.showNotifyCoders = false
          this.$message({
            message: 'Coders Notification Successful',
            type: 'success'
          })
        } catch (err) {
          this.showNotifyCoders = false
          this.$message({
            message: err.message,
            type: 'error'
          })
        }
      },
      reviewListChildRowLink(props) {
        this.showNotifyCoders = !this.showNotifyCoders
        this.$router.push(`/reviews/outpatient/${props.row.ascTableId}`)
      },
      async createLevel2Audit() {
        try {
          this.copyToLevel2Loading = true
          this.copyToLevel2ErrorMessage = null
          const payload = {
            records: this.getSelectedRecords(),
            targetProjectId: this.targetLevel2ProjectId,
            targetCodeType: this.targetCodeType
          }
          await this.RUN_OP_COPYTOLEVEL2(payload)
          this.copyToLevel2SuccessMessage = true
          this.copyToLevel2Loading = false
        } catch (err) {
          this.copyToLevel2Loading = false
          this.copyToLevel2ErrorMessage = err.message || 'An error occurred while copying records to Level 2 Audit'
          console.log(err)
        }
      },
      removeOriginalAuditorColumn() {
        const newCol = 'originalAuditor'
        const existingIdx = this.columns.indexOf(newCol)
        if (existingIdx !== -1) {
          this.columns.splice(existingIdx, 1)
          this.sortableShow = false
          this.$nextTick(() => {
            this.sortableShow = true
          })
        }
      },
      addOriginalAuditorColumn() {
        const newCol = 'originalAuditor'
        const recordTagsIdx = this.columns.indexOf('recordTags')
        const existingIdx = this.columns.indexOf(newCol)
        if (existingIdx === -1) {
          const insertIdx = recordTagsIdx !== -1 ? recordTagsIdx : this.columns.length
          this.columns.splice(insertIdx, 0, newCol)
          this.sortableShow = false
          this.$nextTick(() => {
            this.sortableShow = true
          })
        }
      }
    },
    watch: {
      loading() {
        this.$nextTick(() => {
          // this.attachSortable('opReviewListGrid', this.handleDragStop)
        })
      },
      'project.projectReviewTypeId': {
        handler() {
          if (this.project.projectReviewTypeId === 2) {
            this.addOriginalAuditorColumn()
          } else {
            this.removeOriginalAuditorColumn()
          }
        },
        deep: true
      }
    },
    computed: {
      ...mapState('outpatientReviews/', ['statistics', 'opListSelected', 'opListRecordValidations', 'refreshOpList']),
      ...mapState('rebuttalTracking/', ['refreshOpRebuttalTracking', 'refreshAscRebuttalTracking']),
      ...mapState('managedLists/projects/', ['projectPK', 'project']),
      ...mapState('managedLists/tenantSetup/', ['tenantSetup']),
      ...mapState('dropdowns/', ['dropdowns']),
      ...mapState('user/', ['user']),
      notifyCodersData() {
        if (this.opListSelected.length) {
          const groupedData = this.opListSelected.reduce((r, a) => {
            const found = r.find((f) => {
              return f.coderId === a.coderId
            })
            if (found) {
              found.records.push(a)
            } else {
              r.push({ coderId: a.coderId, coder: a.coder, auditor: this.user.fullName, coderEmail: a.coderEmail, records: [a] })
            }
            return r
          }, [])
          return [...new Set(groupedData)]
        }
        return []
      },
      isAsc() {
        return this.project.outpatientGrouperId === 2
      }
    },
    created: function() {
      this.defaultColumns = JSON.parse(JSON.stringify(this.sortableColumns))
      if (this.project.projectReviewTypeId === 2) {
        this.addOriginalAuditorColumn()
      }
      this.loading = true
      Promise.all([this.GET_DROPDOWNS(this.dropdownsNeeded), this.GET_TENANT_SETUP()]).then(() => {
        this.CONVERT_DROPDOWN_COLUMNFILTERARRAY('reviewLevels').then((response) => {
          this.options.listColumns.reviewLevel = response
          this.loading = false
        })
        // this.setUserProfileSortableColumns()
      })

      const refreshFunc = () => {
        if (this.$refs.opReviewListGrid) {
          this.$refs.opReviewListGrid.getData()
        }
      }

      this.SET_OPLIST_REFRESH_FUNC(refreshFunc)
    },
    mounted: function() {
      // this.initialize()
    },
    activated: function() {
      this.isActivated = true
      this.refreshOpList()
    },
    deactivated: function() {
      this.isActivated = false
      // clear any old validation messages, validation messages can be left around because the form validation gets triggered natively by
      // the browser when users hit the enter key in the form
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate()
      }
      this.CLEAR_OPLIST_SELECTED()
      this.localSelectAll(false) // clear all the selected checkboxes
    },
    components: {
      ReviewsMassDelete,
      OutpatientReviewMassUpdate,
      RecordValidation,
      projectSelector
    }
  }
</script>

<style scoped>
  .button-group-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px; /* Adjust gap as needed */
  }
  #addForm >>> .el-form-item--mini .el-form-item__label {
    margin-bottom: 10px;
  }

  >>> .tagsCol {
    max-width: 100px;
  }
</style>

<style>
  .my-multiselect .multiselect {
    background-color: blue;
  }

  #globalSearch {
    width: 300px;
    padding: 0px 0px 0px 10px;
    float: right;
  }

  .hideColumn {
    display: none;
  }

  .item {
    margin-top: 3px;
    margin-right: 35px;
  }

  .el-badge__content {
    background-color: #20a0ff;
  }

  input[name='vf__selected'] {
    display: none;
  }

  .stats-loading {
    opacity: 0.5;
  }

  .dragOn {
    cursor: move;
  }
</style>
